// frontend/src/utils/updateDismissal.js

// Per-browser, per-version dismissal for the update toast. Stores the id the
// user last dismissed (a live commit id like "c:1a2b3c4d" or a deployment id);
// the next deploy produces a different id and the toast reappears.
const KEY = 'updateToast.dismissedId';

export function getDismissedId() {
  try {
    return localStorage.getItem(KEY) || null;
  } catch (e) {
    return null;
  }
}

export function setDismissedId(id) {
  try {
    if (id) localStorage.setItem(KEY, id);
  } catch (e) {
    /* storage unavailable (private mode) — dismissal just won't persist */
  }
}

export function isDismissed(id) {
  return !!id && getDismissedId() === id;
}
